import React from 'react';
import { withTranslation } from 'react-i18next';

import Heading from '../../components/heading/heading';

import {  Row, Col, Button } from 'react-bootstrap';
import FeatureBox from '../../components/featurebox';
import Link from '../../components/net/link';
import StandoutSection from '../../components/section/standoutsection';

import './featurescontent.scss';

class FeaturesContent extends React.Component {
  render() {
    const { t } = this.props; 
    return (

      <>
      <Row>
      <Col>
      <Heading as="h1" className="page">{t('Features._headline')}</Heading>

      </Col>
      <StandoutSection>
      <p>{t('Features._subheadline')}</p>
    </StandoutSection>

      </Row>



      <Row>

      <Col>
      <Heading as="h2" className="feature-subheadline">{t('Features.training_support_headline')}</Heading>
      </Col>
      </Row>
      <Row>


      <FeatureBox heading={t('Features.calorie_calculation_headline')}
        body={t('Features.calorie_calculation_body')}/>

<FeatureBox heading={t('Features.intake_timing_headline')} body={t('Features.intake_timing_body')}/>

      <FeatureBox heading={t('Features.in_workout_headline')} body={t('Features.in_workout_body')}/>
      </Row>

      <Row>

      <Col>
      <Heading as="h2" className="feature-subheadline">{t('Features.lifestyle_support_headline')}</Heading>
      </Col>
      </Row>
      <Row>

      <FeatureBox heading={t('Features.vegan_headline')}
        body={t('Features.vegan_body')}/>

<FeatureBox heading={t('Features.all_athletes_headline')} body={t('Features.all_athletes_body')}/>

<FeatureBox heading={t('Features.food_tracking_headline')} body={t('Features.food_tracking_body')}/>


</Row>            <Row>

<Col>
<Heading as="h2" className="feature-subheadline">{t('Features.adapt_headline')}</Heading>
</Col>
</Row>
<Row>

<FeatureBox heading={t('Features.recipe_suggestions_headline')}
      body={t('Features.recipe_suggestions_body')}/>



<FeatureBox heading={t('Features.allergies_headline')} body={t('Features.allergies_body')}/>


<FeatureBox heading={t('Features.flexible_planning_headline')} body={t('Features.flexible_planning_body')}/>


</Row>

<Row>
<Col>
<div style={{marginTop: "8rem", marginBottom: "8rem"}}>
    
    <div className="text-center">
    <Link to="/benefits" className="btn btn-secondary btn-lg">{t('components.button_read_more')}</Link>
    </div>
    <div className="text-center">
    {t('fragments.or')}
    </div>
    <div className="text-center">
    <Button href="https://app.nutrfy.com/signup" target="_blank" rel="noopener noreferrer" variant="primary" size="lg">
    {t('components.button_join')}</Button>
    </div>

    
  </div>
  </Col>
</Row>

<Row>
<Col><Heading as="h2" className="text-muted">{t('Features.more_features_headline')}</Heading></Col>
</Row>
<Row>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.mobile_headline')}</Heading>
<p>{t('Features.mobile_body')}</p>
</Col>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.grocery_lists_headline')}</Heading>
<p>{t('Features.grocery_lists_body')}</p>
</Col>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.overrides_headline')}</Heading>
<p>{t('Features.overrides_body')}</p>
</Col>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.intake_strategies_headline')}</Heading>
<p>{t('Features.intake_strategies_body')}</p>
</Col>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.integrations_headline')}</Heading>
<p>{t('Features.integrations_body')}</p>
</Col>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.regional_headline')}</Heading>
<p>{t('Features.regional_body')}</p>
</Col>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.reports_headline')}</Heading>
<p>{t('Features.reports_body')}</p>
</Col>
<Col xs={6} sm={3} className="text-muted"><Heading as="h5">{t('Features.journaling_headline')}</Heading>
<p>{t('Features.journaling_body')}</p>
</Col>

</Row>


</>
    )
  }
}

export default withTranslation()(FeaturesContent);